import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useCoordinates } from "hooks/CoordinatesContext";
import { useOrganization } from "hooks/OrganizationContext";

const mapStyles = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#3a475c",
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#1A1A1A"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#515c6d"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#17263c"
      }
    ]
  }
];

const GoogleMapProject = ({ height, userProjects, markersLoaded, activeTab }: any) => {
  const { coordinates, setCoordinates } = useCoordinates();
  const [refreshMode, setRefreshMode] = useState('');
  const [loading, setLoading] = useState(true);
  const [menuShown, setMenuShown] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<any>(null);
  // const [userProjects, setUserProjects] = useState<any>([]);
  const { selectedOrganization } = useOrganization();
  const [center, setCenter] = useState({
    lat: 24,
    lng: 42.388945,
  });


  useEffect(() => {
    if (coordinates[0] !== null && coordinates[0] !== 0 && coordinates[1] !== null && coordinates[1] !== 0) {
      setCenter({ lat: coordinates[0], lng: coordinates[1] });
    }
  }, [coordinates]);

  useEffect(() => {
    // getAllProjects(selectedOrganization.id);
  }, [selectedOrganization, refreshMode]);

  const containerStyle = {
    width: "100%",
    height: height || "100%",
    maxWidth: "100%",
    maxHeight: "100%"
  };
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCaAnlPllExl2Yuk5G6RENFb0zlBQUXFWY",
  });
  useEffect(() => {
    if (isLoaded) {
      setLoading(false);
    }
  }, [isLoaded, userProjects]);
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const styles = require("./googlemapstyles.json");
  const [map, setMap] = React.useState(null);
  const onLoad = () => {
    setMenuShown(true);
  };

  const filteredData = () => {
    if (activeTab) {
      // const staticData = userProjects.filter((project: any) => project.productId === undefined);
      const filteredData = userProjects.filter((project: any) => project.productId === activeTab);
      // const allData = [ ...staticData, ...filteredData ];
      return filteredData;
    }
    return userProjects;
  };

  return (
    <div className="w-full h-full">
      <GoogleMap
        mapContainerStyle={{ ...containerStyle, position: 'relative', zIndex: 1 }}
        center={center}
        zoom={5.5}
        onLoad={onLoad}
        options={{
          styles: mapStyles,
          disableDefaultUI: false,
          backgroundColor: '#1A1A1A',
          zoomControl: true,
          mapTypeControl: false,
          fullscreenControl: false,
          minZoom: 3,
        }}
      >
        {selectedOrganization.id === '0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f' && markersLoaded && (
          <>
            <Marker
              label={{
                text: "Water Tower",
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{ lat: 26.4, lng: 50 }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_CULTURAL_APP}`, "_self");
              }}
            />
            <Marker
              label={{
                text: "Energy",
                color: "#fff",
                className: "watertowertext",
              }}
              position={{ lat: 27.7, lng: 48.8 }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_ENERGY_APP}`, "_self");
              }}
            />

            <Marker
              label={{
                text: "Leap24",
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{ lat: 25.2, lng: 46.4 }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_LEAP24_APP}`, "_self");
              }}
            />

            <Marker
              label={{
                text: "Data Center",
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{ lat: 24.7, lng: 46.85 }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_DATACENTER_APP}`, "_self");
              }}
            />

            <Marker
              label={{
                text: "Car Simulator",
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{ lat: 21, lng: 39.3 }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_REALESTATE_APP}`, "_self");
              }}
            />

            <Marker
              label={{
                text: "EXPO2030",
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{ lat: 25.2, lng: 46.4 }}
              onClick={() => {
                window.open(`${process.env.REACT_APP_LEAP24_APP}`, "_self");
              }}
            />
          </>
        )}
        {markersLoaded && filteredData().map((project: any) => {
          if (!project.coordinates) return null;

          return (
            <Marker
              key={project.id}
              label={{
                text: project.name,
                color: "#fff",
                className: "watertowertext",
              }}
              icon={{
                url: "/images/default-pin.png",
                scaledSize: new window.google.maps.Size(28, 28),
              }}
              position={{
                lat: project.coordinates[0],
                lng: project.coordinates[1]
              }}
              onClick={() => window.open(project.url, "_blank")}
            />
          );
        })}
      </GoogleMap>
    </div>
  );
};

export default GoogleMapProject;
